import buildEntityActions from 'app/entity/utils/buildEntityActions';
import buildEntityApi from 'app/entity/utils/buildEntityApi';
import buildEntitySelectors from 'app/entity/utils/buildEntitySelectors';
import { selectAppIdOrWb } from 'app/developer-v3/utils/selectors';

export const type = 'cliAppInvitee';

export const api = buildEntityApi(type, (path, getState) => {
  const state = getState();
  const { appId } = selectAppIdOrWb(state);
  return `/api/platform/cli/apps/${appId}/invitees/${path}`;
});

export const selectors = buildEntitySelectors(type, sel => {
  sel.appInvitees = state => sel.all.persistedEntities(state).map(sel.data);
});

export const actions = buildEntityActions(type, selectors, api);
